export default {
  logEntries: [],
  status: {},
  uniqueDetections: [],
  uniqueUserAgents: [],
  uniqueGeoLocations: [],
  uniqueIps: [],
  
};